import React from "react";
import BlogPost from "../../../components/templates/Blog/BlogPost";
import BlogPostSEO from "../../../components/molecules/seo/Blog/BlogPostSEO";
import API_URL from "../../../utils/apiUrl";
import getAuthToken from "../../../utils/getAuthToken";

function BlogPostPage(props) {
    return (
        <>
            <BlogPostSEO blogPost={props.blogPost} />
            <BlogPost {...props.blogPost} />
        </>
    );
}

export default BlogPostPage;

const cacheFile = "temp-blog-post-data.json";
export async function getStaticPaths() {
    const axios = require("axios");
    const fs = require("fs");

    const authToken = await getAuthToken();
    const config = {
        method: "get",
        url: `${API_URL}/blog/blogs/`,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${authToken}`,
        },
    };
    const res = await axios(config);
    const blogPosts = res.data.results;

    const paths = [];
    blogPosts.forEach((post) => paths.push({ params: { slug: post.slug } }));
    console.log(paths);

    // save blog post data to json file
    // we'll need this in the getStaticProps to map slugs to ids
    let data = JSON.stringify(blogPosts);
    fs.writeFileSync(cacheFile, data);

    return {
        paths: paths,
        fallback: false,
    };
}

// This also gets called at build time
export async function getStaticProps({ params }) {
    const htmlFindReplaceElementAttrs = require("html-find-replace-element-attrs");
    const { imageLoader } = require("@image");
    const axios = require("axios");
    const fs = require("fs");

    // read cache
    const rawData = fs.readFileSync(cacheFile);
    const blogPosts = JSON.parse(rawData);

    const pk = blogPosts.find((post) => post.slug === params.slug).id;

    // <------------------------------------------- API call --------------------------------------------------------------->
    const authToken = await getAuthToken();
    const config = {
        method: "get",
        url: `${API_URL}/blog/blogs/${pk}`,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${authToken}`,
        },
    };
    const res = await axios(config);
    const blogPost = res.data;

    blogPost.header_image_file = imageLoader({
        src: blogPost.header_image_file,
        quality: 10,
        cdn: "cloudinary",
    });
    blogPost.body_with_images = htmlFindReplaceElementAttrs.replace(
        blogPost.body_with_images,
        (item) =>
            imageLoader({ src: item.value, quality: 80, cdn: "cloudinary" }),
        {
            tag: "img",
            attr: "src",
        }
    );

    return {
        props: {
            blogPost: blogPost,
        },
        // revalidate: 60 * 60 * 24 * 1, // 1 days
    };
}
